import { EventTracker, TrackingObject } from './event-tracking.service';

export class PostMessageEventTracker implements EventTracker
{
  private targetOrigin: string;

  constructor(targetOrigin)
  {
    this.targetOrigin = targetOrigin;
  }

  public send(track: TrackingObject, autoEvent: boolean = false): void
  {
    window.parent.postMessage(
      {
        data: {
          'event_category': track.category,
          'event_label': track.label,
          'value': track.value,
          'non_interaction': autoEvent
        },
        eventId: track.action,
      },
      this.targetOrigin,
    );
  }
}
